import { render, staticRenderFns } from "./edit-testPaper.vue?vue&type=template&id=3ad7154d&scoped=true&"
import script from "./edit-testPaper.vue?vue&type=script&lang=ts&"
export * from "./edit-testPaper.vue?vue&type=script&lang=ts&"
import style0 from "./edit-testPaper.vue?vue&type=style&index=0&id=3ad7154d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad7154d",
  null
  
)

export default component.exports